import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ListSelectionDialogOptions } from './listselection-dialog';


@Component({
    selector: 'app-listselection-dialog',
    templateUrl: './listselection-dialog.component.html',
    styleUrls: ['./listselection-dialog.component.scss']
})
export class ListSelectionDialogComponent {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    ListOptions?: any[];
    ListLabel?: string;
    ListText?: string;
    ListValue?: string;

    SelectedItem?: any;

    constructor(
        private dialogRef: MatDialogRef<ListSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: ListSelectionDialogOptions,
    ) {
        const self = this;
        self.TitleText = opts.TitleText || 'Information Requested...';
        self.MessageText = opts.MessageText || '';
        self.OKText = opts.OKText || 'Done';
        self.CancelText = opts.CancelText || 'Cancel';

        // Build the options to use in the list for selection from the passed options, along with the text and/or value indicated.
        var tempList = [];

        if (opts.ListOptions != null && opts.ListOptions.length > 0) {
            for (var i = 0, j = opts.ListOptions.length; i < j; ++i) {
                var item = opts.ListOptions[i];

                var itemLabel = null;
                var itemValue = null;

                // First, determine if a text label is indicated. If not, we use the item itself as the label, which could look odd if it's an object.
                itemLabel = ((opts.ListText == null || opts.ListText == '') ? item : item[opts.ListText]);

                // Next, determine if a value field is indicated. If not, we use the item itself as the value.
                itemValue = ((opts.ListValue == null || opts.ListValue == '') ? item : item[opts.ListValue]);

                // Add this item to the list
                tempList.push({
                    text: itemLabel,
                    value: itemValue
                });
            }
        }

        self.ListOptions = tempList;
        self.ListLabel = opts.ListLabel;
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.dialogRef.close(this.SelectedItem);
    }
}
